export default __webpack_public_path__ + "static/media/CGC_Login_logo.0a62862c.png";